<app-toast [message]="toast.message"></app-toast>

<div class="row">

  <div class="col-2 ps-0 sidebar">
    <app-sidebar [items]="menuItems" [current]="currentContent"></app-sidebar>
  </div>
  <div class="col-10 px-0">
    @if (currentContent === 'organizations') {
      <div class="card border-0">
        <h4 class="card-header border-0">
          Third parties
        </h4>
        <div class="card-body">
          <h5 class="filters">Filters</h5>
          <form class="bg-light border rounded-lg px-3 pt-2 pb-1 filters" (ngSubmit)="search()">
            <div class="row">
              <div class="form-group col-md-4">
                <label>Name</label>
                <input type="text" class="form-control" [ngClass]="{ 'is-touched': name }" name="name" [(ngModel)]="name" (change)="search()" placeholder="eg: SdP">
              </div>
              <div class="form-group col-md-4">
                <label>Stakeholder</label>
                <input type="hidden" class="form-control" name="politician" [(ngModel)]="politician">
                <app-search-filter [item]="politician"></app-search-filter>
              </div>
              <div class="form-group col-md-4">
                <label>Notes</label>
                <input type="text" class="form-control" name="notes" [ngClass]="{ 'is-touched': notes }" [(ngModel)]="notes" (change)="search()" placeholder="eg: Notes">
              </div>
            </div>
          </form>
          <hr>
            @if (isLoading.organizations) {
              <p>
                <app-spinner [condition]="isLoading.organizations"></app-spinner>
              </p>
            }
            @if (!isLoading.organizations && organizations?.length === 0) {
              <p>
                Nothing found.
              </p>
            }
            @if (isSearching && !isLoading.organizations && organizations?.length) {
              <p>
                <span class="badge badge-primary">{{count}}</span> results found:
              </p>
            }
            <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3" [ngClass]="{ 'disabled': isLoading.organizations }">
              @for (organization of organizations; track organization) {
                <div class="col mb-3">
                  <app-organization [organization]="organization"></app-organization>
                </div>
              }
            </div>
          </div>
        </div>
      }
      @if (currentContent === 'add-new-organization' && !organizationAdded) {
        <div class="card border-0">
          <h4 class="card-header border-0">
            Third parties &raquo; Add new
          </h4>
          <div class="card-body">
            <app-add-organization-form></app-add-organization-form>
          </div>
        </div>
      }
      @if (currentContent === 'add-new-organization' && organizationAdded) {
        <div class="card border-0">
          <h4 class="card-header border-0">
            Third parties &raquo; Add new
          </h4>
          <div class="card-body">
            <p>
              Third parties added successfully!
            </p>
            <a class="nav-link" [routerLink]="" (click)="currentContent = 'organizations'; organizationAdded = false">
              <i class="fa fa-list"></i> Go to third parties page
            </a>
            <a class="nav-link" [routerLink]="" (click)="addAnotherOrganization()">
              <i class="fa fa-plus-circle"></i> Add another third parties
            </a>
          </div>
        </div>
      }
    </div>

  </div>

